import { Inline, Link } from '@reelplicate/ui';
import { Outlet } from 'react-router';

import { LEGAL_LINKS, marketingUrl } from '@/lib/marketing';

/**
 * Figma "Auth B · Mark field" (Auth Screens ↳ 214:1097 …): a white page, the
 * centred column (wordmark over the card) sitting on a field of faint R marks
 * that fades out radially, and the legal links at the bottom.
 */
export function AuthLayout() {
  return (
    <div className="bg-bg-surface flex min-h-svh flex-col items-center overflow-hidden">
      {/* With the error toast up, Figma drops the column 42px to clear it. */}
      <main className="flex w-full flex-1 items-center justify-center px-4 py-14 has-[[data-auth-toast]]:pt-[140px]">
        <div className="relative flex w-full max-w-[440px] flex-col items-center gap-7">
          {/* BG / Mark field + BG / Fade: 1020 wide behind the column. */}
          <div
            aria-hidden
            className="pointer-events-none absolute -inset-y-[120px] left-1/2 w-[1020px] -translate-x-1/2 bg-[url(/auth/mark-field.png)] bg-size-[340px_340px]"
          >
            <div className="absolute inset-0 bg-[radial-gradient(50%_50%_at_50%_50%,transparent_0%,rgb(255_255_255/0.1)_55%,rgb(255_255_255/0.85)_85%,var(--color-bg-surface)_100%)]" />
          </div>
          <img
            src="/auth/wordmark.svg"
            alt="Reelplicate"
            width={150}
            height={29.5}
            className="relative"
          />
          <div className="relative w-full">
            <Outlet />
          </div>
        </div>
      </main>
      <footer className="relative pb-7">
        <Inline as="nav" aria-label="Legal" gap={5} align="center">
          <span className="text-caption text-text-tertiary">© 2026 Reelplicate</span>
          {(
            [
              ['Privacy', LEGAL_LINKS.privacy],
              ['Terms', LEGAL_LINKS.terms],
              ['Help', LEGAL_LINKS.help],
            ] as const
          ).map(([label, path]) => (
            <Link key={label} asChild tone="neutral" size="sm">
              {/* A new tab, so a half-filled form isn't lost. */}
              <a href={marketingUrl(path)} target="_blank" rel="noreferrer">
                {label}
              </a>
            </Link>
          ))}
        </Inline>
      </footer>
    </div>
  );
}
